import { AfterViewChecked, AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, takeUntil } from 'rxjs';
import { EWB_CREATE_COMPONENTS } from 'src/app/core/enums/ewbConfiguration.enum';
import { CONFIG_MODE } from 'src/app/core/enums/insightConfigurations.enum';
import { SelectedAsset } from 'src/app/core/models/insight-configuration.model';
import { RemoveSelectedAsset, UpdateStepValidity } from 'src/app/core/store/ewb-configuration/ewb-configuration.action';
import { EwbAssetSelectionPopupComponent } from './ewb-asset-selection-popup/ewb-asset-selection-popup.component';

@Component({
  selector: 'app-ewb-asset-selection',
  templateUrl: './ewb-asset-selection.component.html',
  styleUrls: ['./ewb-asset-selection.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EwbAssetSelectionComponent implements OnInit, AfterViewInit, OnDestroy {
  public selectAssetModalRef: BsModalRef
  public selectedAssets: SelectedAsset[] = [];
  public selectedConfigType: any;
  public unsubscribe = new Subject<void>();
  public dataSource = new MatTableDataSource();
  public selectedAsset: SelectedAsset[];
  public count = 0
  public displayedColumns: string[] = ['name', 'buttons'];
  public disable: boolean;

  public assetDuplicatesDetected: boolean = false;
  public mode = CONFIG_MODE.CREATE;

  constructor(
    public router: Router,
    public modalService: BsModalService,
    private readonly store: Store,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) { }

  @ViewChild('scheduledOrdersPaginator', { static: true }) paginator: MatPaginator;

  ngOnInit(): void {
    this.mode = this.store.selectSnapshot(state => state.configurations.ewb.mode);
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.getSelectedAssets();
    this.listenToDuplicates();

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public navigateToLanding(): void {
    this.router.navigateByUrl('/home')
  }

  public getSelectedAssets() {
    this.store.select(state => state.configurations.ewb.assetsSelected).pipe(takeUntil(this.unsubscribe))
      .subscribe(selectedAssets => {
        this.selectedAsset = selectedAssets;
        this.dataSource.data = this.selectedAsset;
        this.count = this.selectedAsset.length

        // get flag for if assets are duplicated
        const duplicated = this.store.selectSnapshot(state => state.configurations.ewb.assetsDuplicateDetected);

        if (this.count > 0) {
          if (duplicated) {
            // Set validity to false if there are duplicates
            this.store.dispatch(new UpdateStepValidity(EWB_CREATE_COMPONENTS.ASSETS, false));
          } else {
            // Set validity to true if there are duplicates
            this.store.dispatch(new UpdateStepValidity(EWB_CREATE_COMPONENTS.ASSETS, true));
          }
        } else if (this.count === 0) {
          // Set validity to false if there are duplicates
          this.store.dispatch(new UpdateStepValidity(EWB_CREATE_COMPONENTS.ASSETS, false));
        }
        this.changeDetectorRef.detectChanges();
      })
  }

  public listenToDuplicates() {
    this.store.select(state => state.configurations.ewb.assetsDuplicateDetected).pipe(takeUntil(this.unsubscribe))
      .subscribe(duplicate => {
        this.assetDuplicatesDetected = duplicate;
      })
  }

  public onSelectAssetClicked() {
    this.selectAssetModalRef = this.modalService.show(EwbAssetSelectionPopupComponent, {
      class: 'modal-lg asset-selection',
      ignoreBackdropClick: true
    })
  }

  public deleteSelectedAsset(asset: any) {
    this.store.dispatch(new RemoveSelectedAsset(asset));
  }

  get CONFIG_MODE() {
    return CONFIG_MODE;
  }
}
